export default "__VITE_ASSET__0b4809a7__"